import React, {useState, useEffect} from 'react'
import { makeStyles } from '@material-ui/core/styles';
// import {
//     makeStyles,
//     BlueButton,DullButton
// } from "component";
// import { checkNotBlank } from "../../Resources/regex.js";
import Checkbox from "@material-ui/core/Checkbox";
import { BlueButton, DullButton } from '../../ReusableComponents/GetButtons/GetButtons';
import "../../ReusableComponents/GetButtons/getButton.css"
import Modal from '@material-ui/core/Modal';
import {useDispatch,addContexts,useSelector} from "../../Redux";
import { useTranslation } from 'react-i18next';
import {
    createSmartFormState,
    sendRequestForControl,
    createUniqueId,
    updateRowNColumn,
    getFormId,
  } from "../../components/IFormDesignerLayout/IFormDesignerLogic";
  import { Backdrop, CircularProgress, Dialog } from '@material-ui/core';
import axios from '../../axios';
import Snackbar from "@material-ui/core/Snackbar";
import Alert from '@material-ui/lab/Alert';
import { useRef } from 'react';
import Switch from '@material-ui/core/Switch';
import secureLocalStorage from 'react-secure-storage';
import cloneDeep from 'lodash-es/cloneDeep';
import ToggleBtn from '../../ReusableComponents/ToggleBtn/ToggleBtn';
import CustomizedAlert from '../../ReusableComponents/Alert/CustomizedAlert';
import { GetStateFromData } from '../../components/CustomHooks/CustomHooks';

const useStyle=makeStyles(()=>(
    {   
        switch: {
            "& .Mui-checked": {
              color: "#0072c5"
              // transform: "translateX(25px) !important"
            },
            "& .MuiSwitch-track": {
              backgroundColor: "#000!important"
            }
          },
        backShade:{
            position:"absolute",
            zIndex:"100",
            height:"100%",
            width:"100%",
            background:"#00000060"
        },
        createNew_PopUp:{
            position:"absolute",
            zIndex:"100",
            // zIndex:"1000",
            left:"50%",
            top:"50vh",
            // height:"35vh",width:"520px",
            height:"392px",
            width:"422px",
            background:"#FFFFFF 0% 0% no-repeat padding-box",
            border:"1px solid #00000040",
            transform:"translate(-50%,-50%)",
            '::placeholder': {
                color: "#c4c4c4"
            }         
        },
        createNew_PopUp_header:{
            borderBottom:"1px solid #00000040",
            textAlign:window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA"? "right":"left",
            fontSize:"14px",
            fontWeight:"600",
            padding:"0 18px", 
            height:"50px",
            lineHeight:"50px"         
        },
        createNew_PopUp_body:{
            padding:"0 18px",
            '& div':{
                display:"flex",
                flexDirection:"column",
                margin:"2px 0",
                justifyContent:"space-between"
            },
            '& label':{
                fontSize:"12px",
                fontWeight:"600",
                color:"#606060",
                display:"block",
                textAlign:window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA"?"right":"left",
                // marginTop:"1em",
                minWidth:"100px",
                lineHeight:"28px"
            },
            '& input, & textarea':{
                display:"block",
                textAlign:window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA"?"right":"left",
                height:"28px",
                // width:"-webkit-fill-available",
                 width: '-moz-available', 
                resize:"none",
                padding:"0 5px",
                fontSize:"12px",
                border:"1px solid #C4C4C4",
                borderRadius: "2px",
                // marginLeft:"5px",
                '&:focus , &:focus-visible , &:hover':{
                    border:"1px solid #C4C4C4",
                    outline:"none"
                }
            },
            '& textarea':{
                height:"84px"
            }
        },
        createNew_PopUp_footer:{
            position:"absolute",
            bottom:"0",
            // borderTop:"1px solid #00000040",
            width:"100%",
            textAlign:window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA"?"left":"right",
            background:"#F5F5F5",
            height:"50px",
            // lineHeight:"49px",
            paddingTop:"5px",
            '& button':{
                margin:"0 6px",
                fontSize:"12px",
                height:"28px",
                minWidth:"54px"
            }
        },
        select:{
            height:"30px"
        },
        errorMsg:{
            color: 'red',
            fontSize: '12px',
            lineHeight: '20px',
            marginLeft: '7px !important',
        },
        inputWrapper:{
            flexDirection: 'column',
              width: '-moz-available'
        },
        dataObjects: { 
            flex: 1, 
            display: 'flex'
        },
        checkLabel: {
            textAlign:window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA"?"right": "left",
            font: "normal normal normal 12px/20px Open Sans",
            letterSpacing: "0px",
            color: "#000000",
            opacity: 1,
        },
        paper: {
            position: 'absolute',
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
          },
          mappingWrap:{
            display: "flex",
            alignItems:"center",
            flexDirection: "row  !important",
            justifyContent:"unset !important"
          },
          mappingWrapSaveTemplate:{
            display: "flex",
            alignItems:"center",
            flexDirection: "row  !important",
            justifyContent:"space-between !important"
          },
          inputSpanWrap:{
            paddingLeft:window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA"?null:"139px",
            flexDirection: "row  !important",
            justifyContent:"unset !important",
            alignItems: "center"
              
          },
          yesNo:{
            paddingLeft:"0px",
            marginRight: "4px",
            fontWeight: 600,
            paddingBottom: "4px"
          },
          dialog: {
            position: "inherit"
          }
    }
))

function SaveTemplate(props) {
    const classes=useStyle();
    
    const { t } = useTranslation();
     
    const contexts = GetStateFromData(props.containerId);
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification"
});
  const jwtToken = contexts.formMataData?.token;
    const {
      updateJson,
      selectedControl,
      changeSectionLayout,
      setOpenProperties,
      formState2,
      setFormState2,
      microFrontendData,
      showAlertConfirmNotifications,
      device
    } = contexts.contexts;
    // const { updatedComponentInFormState, removeAndUpdateComponentInFormState} =updateJson;

    const [error, setError] = useState({});
    const [details, setDetails] = useState({
        name : "",
        description : ""
    })
    const [alert1, setAlert1] = useState({
        open : false,
        severity : "",
        severityMessage : ""
    })
    let newName;
    let newDescription;

    const [checked1, setChecked1] = useState(true);
    const [checked2, setChecked2] = useState(false);
    const [tableStatus, setTableStatus] = useState(2);
    const [showLoader, setShowLoader] = useState(false)
    const [MappingYesNo, setMappingYesNo] = useState(true);
    const inputRef = useRef(null)
    

    // useEffect(() => {
    //     // props.setScreenshot(window.takeScreenshot());
    //     // console.log("page...", props.screenshot);
    //     props.setNewTemplate((prev)=>{
    //         return{
    //             ...prev, "templateimage":props.screenshot
    //         }
    //     });
    // }, [])

    // useEffect(() => {
    //     props.setNewTemplate((prev)=>{
    //         return{
    //             ...prev, "categoryid":-3, "templatecategory": "PAGE"
    //         }
    //     });
    // }, [])

    // useEffect(() => {
    //     if(props.templateType === "page"){
    //         props.setNewTemplate((prev)=>{
    //             return{
    //                 ...prev, "tablestatus": 2
    //             }
    //         });
    //     }
    // }, [])

    // useEffect(() => {
    //     // console.log("page..",window.formBuffer)
    //     if(window.formBuffer){
    //         props.setNewTemplate((prev)=>{
    //             return{
    //                 ...prev, "templatebuffer": JSON.stringify(window.formBuffer)
    //             }
    //         });
    //     }
    // }, [window.formBuffer]);   

    

    // console.log("..", props.newTemplate, window.formBuffer)

    const handleChange1 = (event) => {
        if(event.target.checked){
            setChecked1(event.target.checked);
            setChecked2(!event.target.checked);
        } else {
            setChecked1(!event.target.checked);
            setChecked2(event.target.checked);
        }
        setTableStatus(2);
        // props.setNewTemplate((prev)=>{
        //     return{
        //         ...prev, "tablestatus":2
        //     }
        // });
    }

    const handleChange2 = (event) => {
        if(event.target.checked){
            setChecked2(event.target.checked);
            setChecked1(!event.target.checked);
        } else {
            setChecked2(!event.target.checked);
            setChecked1(event.target.checked);
        }
        setTableStatus(1);
        // props.setNewTemplate((prev)=>{
        //     return{
        //         ...prev, "tablestatus":1
        //     }
        // });
    }

    const checkSubmission = () => {
        let submit = true;
        let newMsg = { ...error }
        var TemplateName = document.getElementById(
            "newApplication_save_temp_name"
          );
        var TemplateDesciption = document.getElementById(
            "newApplication_save_temp_description"
          )
          
        if(TemplateDesciption.value.trim() === "") {
            let json = {
                errorId: "newApplication_save_temp_description",
                errorMsg: "This field cannot be left blank!",
              };
              newMsg["newApplication_save_temp_description"] = json
              setError((prev) => {
                if (prev !== newMsg) {
                  console.log("===> Setting error newMsg!! ", newMsg);
                  return newMsg;
                } else {
                  console.log("===> Setting error prev!! ", prev);
                  return prev;
                }
              });
             return false
        } else if (TemplateName.value.trim() === "") {
            let json = {
                errorId: "newApplication_save_temp_name",
                errorMsg: "This field cannot be left blank!",
              };
              newMsg["newApplication_save_temp_name"] = json;
              setError((prev) => {
                if (prev !== newMsg) {
                  console.log("===> Setting error newMsg!! ", newMsg);
                  return newMsg;
                } else {
                  console.log("===> Setting error prev!! ", prev);
                  return prev;
                }
              });
            return false;
        } else {
            return true
        }
        // let newMsg = {...error};
        // var newApplication_category_id = props.newTemplate?.categoryid;
        //document.getElementById('newApplication_category_id').value;
        // if(newApplication_category_id===''){
        //     submit = submit && false;
        //     let json = {
        //               errorId:'newApplication_category_id',
        //               errorMsg: 'This field can\'t be left blank!',
        //           };
        //     newMsg['newApplication_category_id'] = json;
        // }
        // var newApplication_save_temp_name = props.newTemplate?.categoryname;//document.getElementById('newApplication_save_temp_name').value;
        // if(newApplication_save_temp_name===''){
        //     submit = submit && false;
        //     let json = {
        //               errorId:'newApplication_save_temp_name',
        //               errorMsg: 'This field can\'t be left blank!',
        //           };
        //     newMsg['newApplication_save_temp_name'] = json;
        // }
        // var newApplication_save_temp_description = props.newTemplate?.description;
         //document.getElementById('newApplication_save_temp_description').value;
        // if(newApplication_save_temp_description===''){
        //     submit = submit && false;
        //     let json = {
        //               errorId:'newApplication_save_temp_description',
        //               errorMsg: 'This field can\'t be left blank!',
        //           };
        //     newMsg['newApplication_save_temp_description'] = json;
        // }
        // setError((prev) => {
        //   if (prev !== newMsg) {
        //     console.log("===> Setting error newMsg!! ", newMsg);
        //     return newMsg;
        //   } else {
        //     console.log("===> Setting error prev!! ", prev);
        //     return prev;
        //   }
        // });
        // if (submit) {
        //   if (
        //     error &&
        //     (error["newApplication_category_id"] ||
        //       error["newApplication_save_temp_name"] ||
        //       error["newApplication_save_temp_description"])
        //   ) {
        //     submit = submit && false;
        //   }
        // }
       
    }

    function checkNotBlank(value) {
        if (value.trim().length>=1) {
          return "OK";
        } else {
          return "This field cannot be left blank!";
        }
      }

    const checkRegex = (id, value) => {
      let newMsg = { ...error };
      let msg;
      switch (id) {
        case "newApplication_save_temp_name":
          msg = checkNotBlank(value);
          if (msg !== "OK" && msg !== null && msg !== undefined) {
            let json = {
              errorId: "newApplication_save_temp_name",
              errorMsg: msg,
            };
            newMsg["newApplication_save_temp_name"] = json;
          } else if (msg === "OK") {
            delete newMsg["newApplication_save_temp_name"];
          }
          break;

        case "newApplication_save_temp_description":
          msg = checkNotBlank(value);
          if (msg !== "OK" && msg !== null && msg !== undefined) {
            let json = {
              errorId: "newApplication_save_temp_description",
              errorMsg: msg,
            };
            newMsg["newApplication_save_temp_description"] = json;
          } else if (msg === "OK") {
            delete newMsg["newApplication_save_temp_description"];
          }
          break;

        default:
          break;
      }
      setError((prev) => {
        if (prev !== newMsg) {
          console.log("===> Setting error newMsg!! ", newMsg);
          return newMsg;
        } else {
          console.log("===> Setting error prev!! ", prev);
          return prev;
        }
      });
    };
    const [templateName,setTemplateName] = useState("")
    const [templateNameDescription,setTemplateDescription] = useState("")
    const handleInput = (e, value) => {
      if (value === "name" && /^(?![0-9])[a-zA-Z0-9\u0621-\u064A ]*$/.test(e.target.value)) {
        checkRegex(e.target.id, e.target.value);
        return true;
      } else if (value === "desc") {
        checkRegex(e.target.id, e.target.value);
        return true;
      } else {
        return false;
      }

        
        // if(e.target.id === "newApplication_save_temp_name")
        // setDetails(prev => ({...prev, name : e.target.value}))
        // if(e.target.id === "newApplication_save_temp_description")
        // setDetails(prev => ({...prev, description: e.target.value}))
       

        // props.setNewTemplate((prev)=>{
        //     if(e.target.name==="categoryid"){
        //         return{
        //             ...prev,
        //             [e.target.name]:parseInt(e.target.value),
        //             'categoryname':e.target.options[e.target.selectedIndex].text
        //         } 
        //     } else if(e.target.name==="templatename"){
        //         if(/^[a-zA-Z0-9 _]*$/.test(e.target.value)) {
        //             return{
        //                 ...prev,[e.target.name]:e.target.value
        //             }   
        //         } else {
        //             return{
        //                 ...prev
        //             }  
        //         }
        //     } else {
        //         return{
        //             ...prev,[e.target.name]:e.target.value
        //         }   
        //     }
        // })
    }

    const handleClose3 = (event) => {
        setAlert1({open : false})
      }

    const createNewTemplate = () => {
        const launchpadKey=secureLocalStorage.getItem("launchpadKey");
        let jwtToken1 =JSON.parse(launchpadKey)?.token || undefined;
        const cabinet = secureLocalStorage.getItem("cabinet")
        let newTemplateVar = {tablestatus:0};
        let dateNow = new Date();
        let copySectionBuffer =  cloneDeep((props.sectionBuffer))
        //  let noMappinfField =  removeFromFormState(copySectionBuffer)
        // console.log('@newTemplate :: ',newTemplate);
        newTemplateVar["categoryid"] = -1
        newTemplateVar["categoryname"] = ""
        newTemplateVar['createddatetime'] = dateNow; 
        newTemplateVar['createdby'] = microFrontendData?.sessionData?.sessionData?.userId;
        newTemplateVar['lastAccessedby'] = microFrontendData?.sessionData?.sessionData?.userId;
        newTemplateVar['lastModifiedtime'] = dateNow;
        newTemplateVar['usageCount'] = 0;
        newTemplateVar['templatename'] = newName;
        newTemplateVar['templatebuffer'] = MappingYesNo ? JSON.stringify(props.sectionBuffer) : JSON.stringify(copySectionBuffer) ;
        newTemplateVar['templateimage'] = props.screenShot;
        newTemplateVar['templatetype'] = "USER DEFINED";
        newTemplateVar['description'] = newDescription;
        newTemplateVar["lastAccessedtime"] = dateNow;
        newTemplateVar['lastModifiedby'] = microFrontendData?.sessionData?.sessionData?.userId;
        newTemplateVar['templatecategory'] = 'CONTROL';
        newTemplateVar['formId'] = getFormId();

        //http://localhost:8080/iforms/templates/Templatetype/{PAGE/FORM/TEMPLATE}
        axios.post("/templates/",newTemplateVar, {withCredentials:true})
        .then(res => {
            // props.setSavePageTemplate_popup(false)
            // alert("saved as App Template");
            // setShowAlert(true);
            // setAlertMsg('Saved as App template.');
            // setAlertType('success'); 
            // props.setAlert1({
            //     open : true,
            //     severity : "success",
            //     severityMessage : "The section has been saved as a template successfully.."
            // })
            props?.setAlertData1({
              open: true,
              showConfirm: "showNotification",
              alertType: "success",
              alertContentMsg: `${t("The section has been saved as a template successfully.")}.`
            });
            props.setSavePageTemplate_popup(false)
            // setDetails({name : "", description : ""})
        }).catch(err => {
            const errMessage = err.response.data.error;
            let errorMessage;
            
            if(errMessage === '202')
                errorMessage = "Template_Name_Already_Exists"
            else if(errMessage === '201')
                errorMessage = "Template_Name_Is_Empty"
            else{
              errorMessage="An error occurred while saving the section as a template. Please try again.."
            }

            // props.setAlert1({
            //     open : true,
            //     severity : "error",
            //     severityMessage : `${t(errorMessage)}`
            // })
            setAlertData({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentMsg: `${t(errorMessage)}`
            });
            inputRef.current.focus()
            // setDetails({name : "", description : ""})
        })
    }

    const closeTemplatePopup =()=>{

        var TemplateName = document.getElementById("newApplication_save_temp_name");
        if(TemplateName!==undefined && TemplateName!==null) 
        TemplateName.value='';
        var TemplateDesciption = document.getElementById("newApplication_save_temp_description");
        if (TemplateDesciption !== undefined && TemplateDesciption!==null)
          TemplateDesciption.value = "";
          props.setSavePageTemplate_popup(false)
    }
    const submitApplication=(e)=>{
        e.preventDefault();
        let dateNow = new Date(); 
        try{
        // props.setNewTemplate((prev) => {
        //     return {
        //       ...prev,
        //     //   [e.target.name]: e.target.value,
        //       createddatetime: dateNow,
        //       createdby: "Shivam",
        //       lastAccessedby: "Shivam",
        //       lastModifiedtime: dateNow,
        //       usageCount: 0,
        //       lastAccessedtime: dateNow,
        //       lastModifiedby: "Shivam",
        //       templatebuffer: props.templateType === "app" ? props.activePane.applicationId.toString() : JSON.stringify(window.formBuffer)
        //     //   categoryname:,
        //     };
        // });
        let submit = checkSubmission();
        if (submit){ 
            var TemplateName = document.getElementById(
              "newApplication_save_temp_name"
            );
            // if (TemplateName !== undefined && TemplateName !== null)
            //   TemplateName.value = "";
            // var Category = document.getElementById("newApplication_category_id");

            var TemplateDesciption = document.getElementById(
              "newApplication_save_temp_description"
            );

            newName = TemplateName.value
            newDescription = TemplateDesciption.value
            // setDetails({
            //     name : newName,
            //     description : newDescription
            // })


            if (TemplateName !== undefined && TemplateName !== null)
              TemplateName.value = "";
            if (TemplateDesciption !== undefined && TemplateDesciption !== null)
              TemplateDesciption.value = "";
            // if(props.templateType === "app"){
            //     props.setSaveAppTemplate_popup("closed");
            //     // console.log(props.newTemplate);
            //     props.createNewTemplate("app");
            // } else if(props.templateType === "page"){
            //     props.setSavePageTemplate_popup("closed");
            //     // console.log(props.newTemplate);
            //     props.createNewTemplate();
            // } else if(props.templateType === "form"){
            //     props.setSaveSubformTemplate_popup("closed");
            createNewTemplate();
            // }
            // props.activityStream("Username has added a new interface template "+ props.newTemplate.templatename,305, -1, -1, -1);
        }
        }catch(err){
            console.log('Error:: ',err);
        }
    }

  const removeFromFormState = (formState) => {
    if (formState.children) {
      for(let i=0; i<formState.children.length;i++){
        if (formState.children[i]?.dataclass) {
          delete formState.children[i].dataclass;
          delete formState.children[i].datamapPercision;
          delete formState.children[i].datamapVariableLength;
          delete formState.children[i].datamapVariableType;
          delete formState.children[i].datamapid;
          delete formState.children[i].style.MappingId;
          delete formState.children[i].style.Mapping;
          // formState.children[i].style.Label = formState.children[i].id;

          if((formState.children[i].elem_type === "advancelistView" ||
            formState.children[i].elem_type === "advancelistview" ||
            formState.children[i].elem_type === "listview" ||
            formState.children[i].elem_type === "table") &&
            formState?.children?.[i]?.columnList?.length
          ) {
            formState.children[i].columnList.forEach(col => {
              delete col.style["complexFieldName"];
              delete col.style["associatedControlId"];
              delete col.style["complexFieldType"];
              delete col.style["complexFieldVariableLength"];
              delete col.style["complexFieldVariablePrecision"];
            })
          }
        }
        if (formState.children[i]?.subform && formState.children[i].elem_type === "button") {
          removeFromFormState(formState.children[i].subform);
        }
        else if (
          formState.children[i]?.listviewFrameLayoutJson &&
          (formState.children[i].elem_type === "advancelistView" ||
            formState.children[i].elem_type === "advancelistview" ||
            formState.children[i].elem_type === "listview")
        ) {
          removeFromFormState(formState.children[i].listviewFrameLayoutJson);
        }
        else {
          removeFromFormState(formState.children[i]);
        }
      }
    }
    else {
      return;
    }
  }

    function toggleClick(){
      setMappingYesNo(!MappingYesNo)
    }

    return (
        <>  
            {/* <div className={classes.backShade}></div> */}
            <Dialog open={props.setSavePageTemplate_popup}
            onClose={!props.setSavePageTemplate_popup}
            container={() => {document.getElementById("canvasId")}}
            classes={{paper:classes.dialog}}
            style={{zIndex:1311}}
            >
            {/* <Modal
                
                onClose={!props.setSavePageTemplate_popup}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                > */}
            <div className={`${classes.createNew_PopUp} savetemplatePop_up`}>

                <div className={classes.createNew_PopUp_header} >
                {t("Save Section as Template")}
                    
                </div>

                <div className={classes.createNew_PopUp_body} >                       
                    <div>
                        <label aria-label="Template Name"> {t("Template Name")} <b style={{color:"#D53D3D"}}>*</b> </label>
                        <div className={classes.inputWrapper}>
                            <input 
                                aria-label={"Control Value1"}
                                autoFocus
                                ref={inputRef}
                                id={'newApplication_save_temp_name'} 
                                placeholder={t("Type here")} 
                                autoComplete="off" 
                                value={templateName} 
                                onChange={(e)=>handleInput(e, "name") ? setTemplateName(e.target.value) : null} 
                                name="templatename"  
                                maxLength={50}
                            />
                            {
                                (error['newApplication_save_temp_name'])?
                                <div className={classes.errorMsg}>{t(error['newApplication_save_temp_name']['errorMsg'])}</div>
                                :null
                            }
                        </div>
                    </div> 
                    <div className={classes.mappingWrapSaveTemplate}>
                        <label aria-label="Mapping" for="Mapping" >{t("Keep Data Objects Mapping")} </label> 
                        <div className={classes.inputSpanWrap}>
                        {/* <Switch
                        size="small"
                        checked={MappingYesNo}
                        className={classes.switch}
                        name="checkedB"
                        onChange={()=>setMappingYesNo(!MappingYesNo)}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                        /> */}
                        <ToggleBtn
                        handleToggle={toggleClick}
                        isSaveTemplate={true}
                        // externalStyling={{toggle: {width:"27px"}}}
                        toggleState={MappingYesNo + ""}
                        widthMin={true}
                        externalStyling={{input:{width:"30px",height:"16px"},container:{
                          width:"50px"
                        }}}
                      />
                      <span className={classes.yesNo}>{MappingYesNo ? t("Yes") : t("No")}</span> 
                         </div>
                     </div>                 

                    <div>
                        <label aria-label="Template Description">{t("Template Description")} <b style={{color:"#D53D3D"}}>*</b> </label>
                        <div className={classes.inputWrapper}>
                            <textarea 
                                id={'newApplication_save_temp_description'} 
                                aria-label='Template Description'
                                placeholder={t("Type here")} 
                                value={templateNameDescription} 
                                ref={inputRef}
                                onChange={(e)=>handleInput(e, "desc") ? setTemplateDescription(e.target.value): null} 
                                name="description" 
                                maxLength={window?.psh_configs?.label_max_length}
                            />
                            {
                                (error['newApplication_save_temp_description'])?
                                <div className={classes.errorMsg}>{t(error['newApplication_save_temp_description']['errorMsg'])}</div>
                                :null
                            }
                        </div>
                    </div>

                    {/* <label>Category</label>
                    <select onSelect={()=>{}} >
                        {}
                    </select> */}
                </div>

                <div className={classes.createNew_PopUp_footer}>
                    {   
                        <>
                            <DullButton className="dull-button" onClick={()=>closeTemplatePopup()}>{t("Cancel")}</DullButton>
                            
                            <BlueButton className="blue-button" onClick={(e)=>submitApplication(e)}>{t("Create")}</BlueButton>
                        </>
                    }
                    
                </div>
            </div>
            {/* </Modal> */}
            </Dialog>
            <Dialog open={showLoader}
            container={() => {document.getElementById("canvasId")}}
                onClose={showLoader ? false : true}>
            {/* <Modal
                
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            > */}
                { showLoader === true ? 
                    // <div style={{justifyContent:"center",display:"flex", marginTop:"50px"}}>
                    <div className={classes.paper}>
                    <CircularProgress />
                    {/* Loading..... */}
                    </div> 
                    :
                    <div style={{display:"none"}}>
                    </div>
                            }
            {/* </Modal> */}
            </Dialog>
      {/* {alert1.open === true && alert1.severity === "success" && <Snackbar open={alert1.open} 
      autoHideDuration={4000} onClose={handleClose3} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                 <Alert severity={alert1.severity} style={{width:"290px",backgroundColor:"#C9E29A",color:"#000000", fontFamily:"Open Sans",fontSize:"13px"}}>{alert1.severityMessage}</Alert>
      </Snackbar> 
        }  */}
        {/* {alert1.open === true && alert1.severity === "error" && <Snackbar open={alert1.open } autoHideDuration={3000} onClose={handleClose3} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                 <Alert severity={alert1.severity} style={{width:"290px",backgroundColor:"#D53D3D ",color:"#FFFFFF", fontFamily:"Open Sans",fontSize:"13px"}}>{alert1.severityMessage}</Alert>
      </Snackbar> 
        }   */}
        {
        alertData.open
        &&
        <CustomizedAlert alertData={alertData} />
      }    
        </>
    )
}

export default SaveTemplate
